import { Box, Grid } from "@mui/material";
import Header from "components/Header";
import { useTranslation } from "react-i18next";
import PunchRecordsList from "./List";
import StaffSearch from "components/StaffSearch";
import PersonSearch from "components/PersonSearch";
import DateRangePicker from "components/DateRangePicker/DateRangePicker";
import { useSelectedTeacher } from "../../index";
import NoRecords from "components/NoRecords";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";

const PUNCH_RANGES = {
    'This Week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Past 3 Months': [moment().subtract(2, 'month').startOf('month'), moment().endOf('month')],
}

export default function PunchRecordsListIndex() {
    const { t } = useTranslation()
    const { selectedTeacher, setSelectedTeacher, mode } = useSelectedTeacher()
    const [dateRange, setDateRange] = useState([
        dayjs().startOf('week'),
        dayjs().endOf('week'),
    ])
    const [days, setDays] = useState([])

    const generateDaysForRange = (start, end) => {
        const result = []
        let d = dayjs(start)
        const endDay = dayjs(end)
        while (d.isSame(endDay, 'day') || d.isBefore(endDay, 'day')) {
            result.push({
                DayOfWeek: d.format('dddd'),
                PunchDate: d.format('YYYY-MM-DD'),
            })
            d = d.add(1, 'day')
        }
        return result
    }

    useEffect(() => {
        setDays(generateDaysForRange(dateRange[0], dateRange[1]))
    }, [])

    const handleDateRangeChange = ([start, end]) => {
        setDateRange([start, end])
        setDays(generateDaysForRange(start, end))
    }

    const rangeLabel = `${dayjs(dateRange[0]).format('MMM D')} – ${dayjs(dateRange[1]).format('MMM D, YYYY')}`

    return (
        <Box>
            <Grid container alignItems="center" spacing={2} sx={{ my: 2 }}>
                {mode === 'hr' && (
                    <Grid item md={4} xs={12}>
                        <PersonSearch
                            label={t('Staff Member')}
                            value={selectedTeacher?.person ?? null}
                            onChange={p => setSelectedTeacher(p ? { personId: p.id, person: p } : null)}
                        />
                    </Grid>
                )}
                {mode === 'admin' && (
                    <Grid item md={4} xs={12}>
                        <StaffSearch
                            label={t('Staff Member')}
                            onSelect={setSelectedTeacher}
                            value={selectedTeacher}
                        />
                    </Grid>
                )}

                <Grid item md={mode === 'self' ? 4 : 4} xs={12}>
                    <DateRangePicker
                        label={t('Date Range')}
                        startDate={dateRange[0]}
                        endDate={dateRange[1]}
                        setDateRange={handleDateRangeChange}
                        customRanges={PUNCH_RANGES}
                        allowWeekends
                    />
                </Grid>
            </Grid>

            {selectedTeacher && days.length > 0 ? (
                <>
                    <Header title={t(`Punch Records — ${rangeLabel}`)} small />
                    <PunchRecordsList selectedTeacher={selectedTeacher} days={days} mode={mode} />
                </>
            ) : (
                <NoRecords message={t('Select a staff member to view punch records.')} />
            )}
        </Box>
    )
}
